export default "__VITE_ASSET__BkRNm_yS__"